export default "__VITE_ASSET__BtcSS6qj__$_?nuxt_component=async&nuxt_component_name=IconTermsNConds&nuxt_component_export=default__"